import React, { useEffect } from 'react';
import SwitchesRow from './components/SwitchesRow';
import useAddField from '../../../../../../hooks/useAddField';
import SubtitleRow from './components/SubtitleRow';
import AddFieldsRow from '../../../common/formComponents/AddFieldsRow/AddFieldsRow';
import SwitchFieldForOfficeSubtitle from './components/SwitchFieldForOfficeSubtitle';
import FormWrapper from '../../../common/formComponents/FormWrapper/FormWrapper';
import { chessFieldsNames } from './constants/chessFieldsNames';
import { getChessFieldsData } from './utils/getChessFieldsData';
import FieldsRow from '../../../common/formComponents/FieldsRow/FieldsRow';
import AddressRow from '../common/AddressRow/AddressRow';

const ChessForm = ({ form, initialValues, address }) => {
  const { getFieldDecorator, setFieldsValue, getFieldValue } = form;

  const {
    keys: differentFloorKeys,
    add: addDifferentFloorFields,
    remove: removeDifferentFloorFields,
  } = useAddField({ form, name: chessFieldsNames.differentFloorKeys });

  const differentFloorKeysValue = getFieldValue(
    chessFieldsNames.differentFloorKeys
  );

  const entranceCount = getFieldValue(chessFieldsNames.numberOfEntrances);

  // const {
  //   keys: differentNumberOfFlatsKeys,
  //   add: addDifferentNumberOfFlatsKeysFields,
  //   remove: removeDifferentNumberOfFlatsFields,
  // } = useAddField({
  //   form,
  //   name: chessFieldsNames.differentNumberOfFlatsKeys,
  // });

  // const {
  //   keys: officeKeys,
  //   add: addOfficeFields,
  //   remove: removeOfficeFields,
  // } = useAddField({
  //   form,
  //   name: chessFieldsNames.officeKeys,
  //   initialNumOfFields: 1,
  // });

  // установить чекбокс с офисным этажом в false
  // useEffect(() => {
  //   if (officeKeys.length === 0) {
  //     setFieldsValue({ [chessFieldsNames.isOfficeFloor]: false });
  //   }
  // }, [officeKeys, setFieldsValue]);

  // const isOfficeFloor = getFieldValue(chessFieldsNames.isOfficeFloor);
  // const isNumbering = getFieldValue(chessFieldsNames.isNumbering);

  // const officesFloorsFields = officeKeys.map(
  //   (key) => `${chessFieldsNames.officeFloor}-${key}`
  // );
  // const differentNumberOfFlatsFields = differentNumberOfFlatsKeys.map(
  //   (key) => `${chessFieldsNames.differentNumberOfFlatsFloor}-${key}`
  // );

  // const groundFloorDependentFields = [
  //   ...differentNumberOfFlatsFields,
  //   ...officesFloorsFields,
  // ];

  const {
    firstRowFields,
    сhangeNumOfFloorsFields,
    // сhangeNumOfFlatsFields,
    // officeEntranceFields,
    // fromFlatNumberFields,
    // switchesFields,
  } = getChessFieldsData({
    initialValues,
    form,
    // groundFloorDependentFields,
  });

  return (
    <FormWrapper>
      <AddressRow address={address} />
      <FieldsRow
        gutter={16}
        form={form}
        fields={firstRowFields}
        rowType="row"
      />

      {/* <SwitchesRow
        getFieldDecorator={getFieldDecorator}
        fields={switchesFields}
      /> */}

      {/* {isNumbering && <FieldsRow form={form} fields={fromFlatNumberFields} />} */}

      {entranceCount ? (
        <>
          <SubtitleRow subtitle="Изменить этажность в подъезде" />

          {differentFloorKeys.map((key) => (
            <FieldsRow
              key={key}
              form={form}
              fields={сhangeNumOfFloorsFields}
              onRemoveField={() => removeDifferentFloorFields(key)}
              gutter={16}
              rowType="field"
              index={key}
            />
          ))}

          {differentFloorKeysValue.length < entranceCount && (
            <AddFieldsRow
              text="Добавить исключение"
              addFieldsFunc={addDifferentFloorFields}
            />
          )}
        </>
      ) : null}

      {/* <SubtitleRow subtitle="Изменить количество квартир на этаже" /> */}

      {/* {differentNumberOfFlatsKeys.map((key) => (
        <FieldsRow
          key={key}
          form={form}
          fields={сhangeNumOfFlatsFields}
          onRemoveField={() => removeDifferentNumberOfFlatsFields(key)}
          gutter={16}
          rowType="field"
          index={key}
        />
      ))} */}

      {/* <AddFieldsRow
        text="Добавить исключение"
        addFieldsFunc={addDifferentNumberOfFlatsKeysFields}
      /> */}

      {/* {isOfficeFloor && (
        <>
          <SubtitleRow
            subtitle="Офисный этаж"
            switchField={
              <SwitchFieldForOfficeSubtitle
                getFieldDecorator={getFieldDecorator}
              />
            }
          />
          {officeKeys.map((key) => (
            <FieldsRow
              key={key}
              form={form}
              fields={officeEntranceFields}
              onRemoveField={() => removeOfficeFields(key)}
              gutter={16}
              rowType="field"
              index={key}
            />
          ))}
          <AddFieldsRow
            text="Добавить офисный этаж"
            addFieldsFunc={addOfficeFields}
          />
        </>
      )} */}
    </FormWrapper>
  );
};

export default ChessForm;
